import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userSlice from "./userSlice";

const reducer = combineReducers({
    user: persistReducer(
        {
            key: 'user',
            storage,
            keyPrefix: 'appello-'
        },
        userSlice
    ),
});

export default reducer;